import create from 'zustand';
import { devtools } from 'zustand/middleware';

interface Actions {
  setTargetVoucher: (payload: string) => void;
  clearTargetVoucher: () => void;
  toggleDialog: (payload: boolean) => void;
  toggleTooltip: (payload: boolean) => void;
  updateFirstTimeAccessPDP: () => void;
}

interface ProductDetailPriceStore {
  targetVoucherCode: string;
  isOpenDialog: boolean;
  isOpenTooltip: boolean;
  isFirstTimeAccessPDP: boolean;
}

type InitialDetailPriceState = ProductDetailPriceStore;
type DetailPriceState = InitialDetailPriceState & { actions: Actions };

const INITIAL_STATE: InitialDetailPriceState = {
  targetVoucherCode: '',
  isOpenDialog: false,
  isOpenTooltip: false,
  isFirstTimeAccessPDP: true,
};

const useDetailPriceStates = create<DetailPriceState>()(
  devtools((set, get) => ({
    ...INITIAL_STATE,
    actions: {
      setTargetVoucher: (payload) => {
        set({ targetVoucherCode: payload });
      },
      clearTargetVoucher: () => {
        set({ targetVoucherCode: '' });
      },
      toggleDialog: (payload) => {
        set({ isOpenDialog: payload });
      },
      toggleTooltip: (payload) => {
        set({ isOpenTooltip: payload });
      },
      updateFirstTimeAccessPDP: () => {
        set({ isFirstTimeAccessPDP: false });
      },
    },
  })),
);

export const useDetailPriceActions = () => useDetailPriceStates((state) => state.actions);

export default useDetailPriceStates;
